/**
 * Main Menu
 */
;(function ($) {
	var body = $('body')
	var ww = $(window).width()
	// var nww = ww
	var rww = ww
	// let rwh = $(window).height()
	// // var rwh = wh
	// let headerH = $('#header').height()
	// $(window).resize(function () {
	// 	rww = $(window).width()
	// 	// eslint-disable-next-line no-unused-vars
	// 	rwh = $(window).height()
	// 	// eslint-disable-next-line no-unused-vars
	// 	headerH = $('#header').height()
	// })

	// Media Queries
	var mobile = 1024

	// Navigation
	$('.nav-primary__toggle').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)
		var panel = $('.menu--panel')
		var expandend = $this.attr('aria-expanded') === 'false' ? 'true' : 'false'
		var hidden = panel.attr('aria-hidden') === 'false' ? 'true' : 'false'
		body.toggleClass('menu-main-open')
		panel.toggleClass('open')
		$this.attr('aria-expanded', expandend)
		panel.attr('aria-expanded', expandend)
		panel.attr('aria-hidden', hidden)
		if (expandend === 'true') {
			$('li.menu-item-has-children').removeClass('submenu-opened')
		}
	})

	function openSubMenu(handle) {
		var submenu = handle.find('.sub-menu')
		handle.addClass('submenu-opened').attr('aria-expanded', 'true')
		submenu.slideDown()
		submenu.attr('aria-expanded', 'true').attr('aria-hidden', 'false')
	}

	function closeSubMenu(handle) {
		var submenu = handle.find('.sub-menu')
		handle.removeClass('submenu-opened').attr('aria-expanded', 'false')
		submenu.slideUp()
		submenu.attr('aria-expanded', 'false').attr('aria-hidden', 'true')
	}

	if (rww < mobile) {
		$('li.menu-item-has-children > .menu-item-icon').on('click', function (e) {
			e.preventDefault()
			var handle = $(this).parent()
			if (!handle.hasClass('submenu-opened') && !body.hasClass('drilldown-submenu-opened')) {
				body.addClass('drilldown-submenu-opened')
				openSubMenu(handle)
				$(this).html('-')
			} else if (!handle.hasClass('submenu-opened') && body.hasClass('drilldown-submenu-opened')) {
				var openedSubmenu = $('li.menu-item-has-children.submenu-opened')
				openSubMenu(handle)
				closeSubMenu(openedSubmenu)
				$(this).html('-')
				openedSubmenu.find('.menu-item-icon').html('+')
			} else {
				body.removeClass('drilldown-submenu-opened')
				closeSubMenu(handle)
				$(this).html('+')
			}
		})
	}

	if (rww >= mobile) {
		$('li.menu-item-has-children > a').on('keydown', function (e) {
			if (e.keyCode === 13) {
				e.preventDefault()
				var handle = $(this).parent()
				if (!handle.hasClass('submenu-opened') && !body.hasClass('drilldown-submenu-opened')) {
					body.addClass('drilldown-submenu-opened')
					openSubMenu(handle)
				} else if (!handle.hasClass('submenu-opened') && body.hasClass('drilldown-submenu-opened')) {
					var openedSubmenu = $('li.menu-item-has-children.submenu-opened')
					openSubMenu(handle)
					closeSubMenu(openedSubmenu)
				} else {
					body.removeClass('drilldown-submenu-opened')
					closeSubMenu(handle)
				}
			}
		})

		$(document).keydown(function (e) {
			if (e.keyCode === 27) {
				body.removeClass('drilldown-submenu-opened')
				var openedSubmenu = $('li.menu-item-has-children.submenu-opened')
				closeSubMenu(openedSubmenu)
			}
		})
	}

	if (rww >= mobile) {
		$('li.menu-item-has-children > a').on('mouseenter', function (e) {
			// e.preventDefault()
			var handle = $(this).parent()
			if (!handle.hasClass('submenu-opened')) {
				var openedSubmenu = $('li.menu-item-has-children.submenu-opened')
				body.addClass('drilldown-submenu-opened')
				closeSubMenu(openedSubmenu)
				openSubMenu(handle)
			} else {
				closeSubMenu(handle)
				body.removeClass('drilldown-submenu-opened')
			}
			$('.header-news').slideDown()
		})
		$('.site-header').on('mouseleave', function (e) {
			e.preventDefault()
			var openedSubmenu = $('li.menu-item-has-children.submenu-opened')
			body.removeClass('drilldown-submenu-opened')
			closeSubMenu(openedSubmenu)
			$('.header-news').slideUp()
		})
	}

	$('li.menu__item-drilldown-back > a').on('click', function (e) {
		e.preventDefault()
		var handle = $(this).parents('.menu-item-has-children')
		body.removeClass('drilldown-submenu-opened')
		closeSubMenu(handle)
	})

	// Submenu

	function mScrollOpenSection(section) {
		$('html, body').animate({ scrollTop: section.offset().top - 70 }, 750)
		section.find('.accordeon__toggle').trigger('click')
		window.location.hash = section.get(0).id
	}

	$('li.current-menu-item .sub-menu a[data-type="hash"]').on('click', function (e) {
		e.preventDefault()
		var href = $(this).attr('href')
		var hrefHash = href.substr(href.indexOf('#'))
		var section = $(hrefHash)
		mScrollOpenSection(section)
		if (rww < mobile) {
			$('.nav-primary__toggle').trigger('click')
		}
	})

	$(document).ready(function () {
		var onLoadHash = window.location.hash
		if (onLoadHash !== '') {
			var section = $(onLoadHash)
			mScrollOpenSection(section)
		}
	})

	var siteHeader = $('.site-header')
	var h = $(window).height()
	if (siteHeader.hasClass('site-header--transparent')) {
		$(document).on('scroll', function () {
			var top = $(window).scrollTop()
			if (top > h) {
				siteHeader.removeClass('site-header--transparent').addClass('site-header--persistent')
			} else if (top < h) {
				siteHeader.addClass('site-header--transparent').removeClass('site-header--persistent')
			}
		})
		siteHeader.on('mouseenter', function () {
			$(this).removeClass('site-header--transparent')
		})
		siteHeader.on('mouseleave', function () {
			$(this).addClass('site-header--transparent')
		})
	}

	// $(document).on('scroll', function () {
	// 	var top = $(window).scrollTop()
	// 	if (top > h) {
	// 		body.addClass('scrolled-100')
	// 	} else if (top < h) {
	// 		body.removeClass('scrolled-100')
	// 	}
	// })

	/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
	// if (rww >= mobile) {
	// 	var prevScrollpos = window.pageYOffset
	// 	window.onscroll = function () {
	// 		var currentScrollPos = window.pageYOffset
	// 		if (prevScrollpos > currentScrollPos) {
	// 			document.getElementById('header').style.top = '0'
	// 		} else {
	// 			document.getElementById('header').style.top = '-70px'
	// 		}
	// 		prevScrollpos = currentScrollPos
	// 	}
	// }
})(jQuery)
